import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { RouteComponentProps } from 'react-router'

import NavigationHeader from 'components/NavigationHeader'
import CenteredContent from 'components/CenteredContent'
import ActionContext from 'components/ActionContext'
import T from 'components/FormattedMessage'

import { Typography, createStyles, WithStyles, withStyles } from '@material-ui/core'

import { Action } from 'types'

import { setupFontRules, setupAutoResize } from './utils'

interface Props {
}

const styles = createStyles({
  root: {
    minHeight: '100vh',
    backgroundColor: '#fff',
  },
  header: {
    backgroundColor: '#fff',
  },
  iframe: {
    maxWidth: '100%',
  },
  iframeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
})

type State = {
  html: Action<string>
}

type InjectedProps = Props & WrappedComponentProps & WithStyles<typeof styles> & RouteComponentProps<{}>

class RulesLayer extends React.Component<InjectedProps, State> {
  constructor(props: InjectedProps) {
    super(props)
    this.state = {
      html: { isLoading: true },
    }

    this.requestRulesHtmlSource()
  }

  get htmlAssetFolder() {
    const params = new URLSearchParams(this.props.location.search)
    return params.get('type') === 'classic'
      ? 'classic'
      : 'standard'
  }

  requestRulesHtmlSource = async () => {
    const { intl } = this.props

    try {
      // read the appropriate HTML file as text
      let htmlSource: string = (await import(`raw-loader!./assets/${this.htmlAssetFolder}/${intl.locale}.html`)).default

      // replace the %AppName and %Currency tokens with translations
      htmlSource = htmlSource
        .replace(new RegExp(`%AppName`, 'g'), intl.formatMessage({ id: 'app_name' }))
        .replace(new RegExp(`%Currency`, 'g'), intl.formatMessage({ id: 'scoring_currency' }))

      // remove existing @font-face CSS declarations
      htmlSource = htmlSource
        .replace(new RegExp('@font-face {[^}]*}', 'g'), '')
        .replace(new RegExp('SohoGothicPro', 'g'), 'Flama')

      // replace the URLs of the SVG images
      for (let match of htmlSource.match(/[^"]*\.svg/g)!) {
        const fileNameWithoutExtension = match.match(/([^"]*)\.svg/)![1]
        const newUrl = (await import(`./assets/${fileNameWithoutExtension}.svg`)).default

        htmlSource = htmlSource.replace(new RegExp(match, 'g'), newUrl)
      }

      // save the final HTML code to local state
      this.setState({ html: { isLoading: false, result: htmlSource } })
    } catch (err) {
      this.setState({ html: { isLoading: false, errorCode: err.message } })
    }
  }

  setIframeRef = (iframe: HTMLIFrameElement) => {
    const { result } = this.state.html

    if (result && iframe) {
      const doc = iframe.contentWindow!.document

      doc.open('text/html')
      doc.write(result)
      doc.close()

      setupFontRules(iframe)
      setupAutoResize(iframe)
    }
  }

  renderContent = () => {
    const { classes } = this.props

    return (
      <>
        <Typography variant="h5" align="center">
          <T id="scoring_title" />
        </Typography>
        <CenteredContent className={classes.iframeContainer}>
          <iframe
            title="rules"
            width="100%"
            scrolling="no"
            frameBorder="no"
            ref={this.setIframeRef}
            className={classes.iframe}
          />
        </CenteredContent>
      </>
    )
  }

  render() {
    const { classes, history } = this.props
    const { html } = this.state

    return (
      <div className={classes.root}>
        <NavigationHeader
          className={classes.header}
          title={<T id="scoring_title" />}
          onBackClick={history.goBack}
        />
        <ActionContext
          isLoading={html.isLoading}
          errorCode={html.errorCode}
          component={this.renderContent}
          componentProps={{}}
        />
      </div>
    )
  }
}

export default withStyles(styles)(injectIntl(RulesLayer))
